import fetch from 'lib/fetch'
import { apiV3RegistryGiftGiversPath } from 'lib/urls'

import { GiftGiver, GiftGiversSort } from './GiftGiversProvider.types'

import { fakeDataScenario, shouldRequestFakeData } from './fakeData'

interface QueryParamsParams {
  search: string | null
  sort: GiftGiversSort
  cursor: string | null
}
interface QueryPathParams {
  registryId: string | number | undefined
  search: string | null
  sort: GiftGiversSort
  cursor: string | null
}
interface GiftGiversApiResponse {
  giftGivers: GiftGiver[]
  paginationInfo: {
    hasMore: boolean
    cursor: string | null
  }
}
interface FetchAllGiftGiversParams {
  registryId: string | number | undefined
  search: string | null
  sort: GiftGiversSort
}

const queryParams = ({ search, sort, cursor }: QueryParamsParams) => {
  const urlSearchParams = new URLSearchParams({
    orderBy: sort.field,
    orderDirection: sort.direction,
  })

  if (cursor) {
    urlSearchParams.append('cursor', cursor)
  }

  if (search) {
    urlSearchParams.append('query', search)
  }

  if (shouldRequestFakeData()) {
    urlSearchParams.append('fake_data', 'true')

    const scenario = fakeDataScenario()
    if (scenario) {
      urlSearchParams.append('scenario', scenario)
    }
  }

  return urlSearchParams.toString()
}

const queryPath = ({ registryId, search, sort, cursor }: QueryPathParams) =>
  `${apiV3RegistryGiftGiversPath(registryId)}?${queryParams({ search, sort, cursor })}`

const fetchAllGiftGivers = async ({
  registryId,
  search,
  sort,
}: FetchAllGiftGiversParams): Promise<GiftGiver[]> => {
  let giftGivers: GiftGiver[] = []

  if (!registryId) {
    return giftGivers
  }

  let hasMore: boolean
  let cursor: string | null = null
  do {
    // eslint-disable-next-line no-await-in-loop
    const response: GiftGiversApiResponse = await fetch(
      queryPath({ registryId, search, sort, cursor }),
      {
        method: 'GET',
      }
    )

    const {
      giftGivers: nextGiftGivers,
      paginationInfo: { hasMore: nextHasMore, cursor: nextCursor },
    } = response

    hasMore = nextHasMore
    cursor = nextCursor
    giftGivers = [...giftGivers, ...nextGiftGivers]
  } while (hasMore)

  return giftGivers
}

export default fetchAllGiftGivers
